import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { HsgUserProfile, HsgUserService } from '@hhsg/hsg-asc';

import { Client } from '../../../../shared/models/client.model';
import { ClientService } from '../../../../shared/services/client.service'
import { Constants } from '../../../../shared/utilities/constants.util';
import { PageLayoutService } from '../../../../shared/services/page-layout.service';

@Component({
    selector: 'smt-client-impersonation',
    templateUrl: './client-impersonation.component.html',
    styleUrls: ['./client-impersonation.component.scss'],
    providers: [ PageLayoutService ]
})
export class ClientImpersonationComponent implements OnInit {
    private _unsubscribe$ = new Subject();

    clients : Client[];
    client: Client;

    constructor(
        private _clientService: ClientService,  
        private _hsgUserService: HsgUserService, 
        private _pageLayoutService: PageLayoutService) { 
    }

    ngOnDestroy(): void {
        this._pageLayoutService.clearLayoutStyle();
    }

    ngOnInit() {
        this._pageLayoutService.setLayoutStyle('form');
        
        this.loadForm();
    }

    async loadForm() {
        let huronClientId = sessionStorage.getItem(Constants.HuronAdminClientId);

        this._hsgUserService.getUserProfile()
                                .pipe(takeUntil(this._unsubscribe$))
                                .subscribe((userProfile: HsgUserProfile) => {                                                                      
                                    this._clientService.getClients()
                                    .then((result) => {
                                        this.clients = result;

                                        if (userProfile.hasDataRestrictions) {
                                            this.clients.forEach(item => item.disabled = item.hasDataRestrictions);
                                        }
                                        if (huronClientId && this.clients) {
                                            this.client = this.clients.find(c => c.id == +huronClientId);
                                        }
                                        else if (this.clients) {
                                            this.client = this.clients[0];
                                        }

                                        this.onClientChange(this.client.id);
                                        sessionStorage.setItem(Constants.HuronAdminClientId, this.client.id.toString());
                                    });
                                });        
    }

    onClientChange(id: number) {
        sessionStorage.setItem(Constants.HuronAdminClientId, id.toString());
        this.client = this.clients.find(c => c.id == id);

        if (this.client) { 
            this._hsgUserService.getUserProfile()
                                .pipe(takeUntil(this._unsubscribe$))
                                .subscribe((userProfile: HsgUserProfile) => {                                                                        
                                    userProfile.brandingName = this.client.name;
                                });
        }
    }
}
